import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';
const STRINGS = appStrings.modules.careerPath.summaryPage.strongFitPaths;

export function FitPathsLegend() {
  return (
    <Box sx={legendItemsStyle}>
      <Box sx={legendItemStyle}>
        <AppIcon diameter="8px" iconName="Circle" color="Brand/700" fill="Brand/700" />
        <Typography variant="text-sm-regular">{STRINGS.strongFit}</Typography>
      </Box>
      <Box sx={legendItemStyle}>
        <AppIcon diameter="8px" iconName="Circle" color="Brand/500" fill="Brand/500" />
        <Typography variant="text-sm-regular">{STRINGS.mediumFit}</Typography>
      </Box>
      <Box sx={legendItemStyle}>
        <AppIcon diameter="8px" iconName="Circle" color="Brand/200" fill="Brand/200" />
        <Typography variant="text-sm-regular">{STRINGS.lowFit}</Typography>
      </Box>
    </Box>
  );
}

const legendItemsStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: backrs.spacing['spacing-lg'],
  flexWrap: 'wrap',
});

const legendItemStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
  minWidth: 'fit-content',
});
